import IpawsAffectedAreaSection from '../IpawsAffectedAreaSection/IpawsAffectedAreaSection';
import IpawsAudioSection from '../IpawsAudioSection/IpawsAudioSection';
import IpawsEventClassificationSection from '../IpawsEventClassificationSection/IpawsEventClassificationSection';
import IpawsMessageHandlingSection from '../IpawsMessageHandlingSection/IpawsMessageHandlingSection';
import IpawsPublicMessageSection from '../IpawsPublicMessageSection/IpawsPublicMessageSection';
import IpawsTimingSection from '../IpawsTimingSection/IpawsTimingSection';

/** Shared IPAWS authoring fields. Each workflow owns its draft and submission boundary. */
const IpawsAuthoringSections = ({
  draft,
  findings = [],
  contractOptions,
  environment,
  authorizedWeaHandlingOptions,
  isWeaHandlingLoading = false,
  isWeaHandlingError = false,
  channelRules,
  onDraftChange,
  onTextChange,
  onDateTimeChange,
  authorizedAreas,
  permittedArea,
  hasReviewedDraft = false,
  onReviewDraft,
  onClearJurisdiction,
  onSelectAuthorizedJurisdiction,
  audio,
  onAudioChange,
  renderArea = true,
  showIntervalDuration = false,
  statusHelp = null,
}) => (
  <>
    <IpawsMessageHandlingSection
      draft={draft}
      findings={findings}
      contractOptions={contractOptions}
      onDraftChange={onDraftChange}
      onTextChange={onTextChange}
      statusHelp={statusHelp}
    />
    <IpawsEventClassificationSection
      draft={draft}
      findings={findings}
      contractOptions={contractOptions}
      environment={environment}
      authorizedWeaHandlingOptions={authorizedWeaHandlingOptions}
      isWeaHandlingLoading={isWeaHandlingLoading}
      isWeaHandlingError={isWeaHandlingError}
      channelRules={channelRules}
      onDraftChange={onDraftChange}
      onTextChange={onTextChange}
    />
    <IpawsPublicMessageSection
      draft={draft}
      findings={findings}
      onDraftChange={onDraftChange}
      onTextChange={onTextChange}
    />
    {audio && draft.deliveryChannels?.includes('EAS') ? (
      <IpawsAudioSection file={audio.file} duration={audio.duration} onChange={onAudioChange} />
    ) : null}
    <IpawsTimingSection
      draft={draft}
      findings={findings}
      onDraftChange={onDraftChange}
      onDateTimeChange={onDateTimeChange}
      expiryLimits={channelRules?.expiryLimits}
      showIntervalDuration={showIntervalDuration}
    />
    {renderArea ? (
      <IpawsAffectedAreaSection
        draft={draft}
        findings={findings}
        permittedArea={permittedArea}
        hasReviewedDraft={hasReviewedDraft}
        onTextChange={onTextChange}
        onReviewDraft={onReviewDraft}
        onClearJurisdiction={onClearJurisdiction}
        authorizedAreas={authorizedAreas}
        onSelectAuthorizedJurisdiction={onSelectAuthorizedJurisdiction}
      />
    ) : null}
  </>
);

export default IpawsAuthoringSections;
